module.exports = __webpack_public_path__ + "img/drh5_language_kr.51355199.png";